// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--1K8fP","inverted":"button-module--inverted--1Sd_1"};